
import useTranslation from "./Hooks/UseTranslation";
import { PROGRAMMATION_NAVIGATION } from "./Pages/ProjectProgrammation/programmation-navigation";

type Submenu = {
    text: string;
    path: string;
    icon: string;
    active: boolean;
    disabled?: boolean;
    itemWidth?: number;
    alignRight?: boolean;
}

type Menu = {
    text: string;
    textWidth?: number;
    path: string;
    icon: string;
    active: boolean;
    submenu?: Submenu[];
    disabled?: boolean;
    itemWidth?: number;
    alignRight?: boolean;
}

type Navigation = [
    Menu[],
    Submenu[]
]

const getNavigation = (project_id: string, active_menu: string, active_submenu: string): Navigation => {

    const { t } = useTranslation()

    const projectPath = (path: string) => project_id ? `/project/${project_id}${path}` : '/'

    const getShellMenu = () => [
        {
            text: 'Proyectos',
            path: `/`,
            icon: `icon-mis_proyectos`,
            active: active_menu === 'homepage',
            itemWidth: 126,
        },
        {
            text: t('NAVIGATION:Start'),
            path: projectPath('/'),
            icon: `icon-dashboard`,
            active: active_menu === 'start' || active_menu === 'home',
            disabled: !project_id,
            itemWidth: 102,
        },
        {
            text: t('NAVIGATION:Teams'),
            path: projectPath('/teams'),
            icon: `icon-equipos`,
            active: active_menu === 'teams',
            disabled: !project_id,
            itemWidth: 116,
        },
        {
            text: t('NAVIGATION:Programmation'),
            path: projectPath('/programmation-macro'),
            icon: `icon-programacion`,
            active: active_menu === 'programmation',
            disabled: !project_id,
            itemWidth: 154,
            submenu: PROGRAMMATION_NAVIGATION.map((tab) => ({
                text: t(tab.translationKey),
                path: projectPath(tab.path),
                icon: tab.icon,
                active: active_submenu === tab.id,
                disabled: !project_id,
                itemWidth: tab.itemWidth,
            })),
        },
        {
            text: t('NAVIGATION:Tasks'),
            path: projectPath('/tasks'),
            icon: `icon-tareas`,
            active: active_menu === 'tasks',
            disabled: !project_id,
            itemWidth: 112,
            submenu: [
                {
                    text: t('NAVIGATION:TasksBoard'),
                    path: projectPath('/tasks'),
                    icon: `icon-tablero`,
                    active: active_submenu === 'board',
                    disabled: !project_id,
                    itemWidth: 118,
                },
                {
                    text: t('NAVIGATION:TasksDataBase'),
                    path: projectPath('/tasks-archive'),
                    icon: `icon-base_de_datos`,
                    active: active_submenu === 'archive',
                    disabled: !project_id,
                    itemWidth: 142,
                },
            ],
        },
        {
            text: t('NAVIGATION:Resources'),
            path: projectPath('/resources/restrictions'),
            icon: `icon-recursos`,
            active: active_menu === 'resources',
            disabled: !project_id,
            itemWidth: 124,
            submenu: [
                {
                    text: t('NAVIGATION:ResourcesRestrictions'),
                    path: projectPath('/resources/restrictions'),
                    icon: `icon-restricciones_recurso`,
                    active: active_submenu === 'restrictions',
                    disabled: !project_id,
                    itemWidth: 150,
                },
                {
                    text: t('NAVIGATION:ResourcesCNC'),
                    path: projectPath('/resources/cnc'),
                    icon: `icon-cnc_recurso`,
                    active: active_submenu === 'cnc',
                    disabled: !project_id,
                    itemWidth: 94,
                },
            ],
        },
        {
            text: 'BIM',
            path: `/`,
            icon: `icon-recursos`,
            active: false,
            disabled: true,
            itemWidth: 86,
        },
        {
            text: 'Protocolos',
            path: `/`,
            icon: `icon-tareas`,
            active: false,
            disabled: true,
            itemWidth: 130,
        },
        {
            text: 'Configuración',
            path: `/profile`,
            icon: `icon-configuracion`,
            active: active_menu === 'profile',
            itemWidth: 154,
            alignRight: true,
        },
    ]

    const menu = getShellMenu()
    const submenu = project_id
        ? menu.find((item: any) => item.active)?.submenu || []
        : []

    return [ menu, submenu ]
}

export default {
    getNavigation,
}
